import { ApiData, ApiDescription, RequestsMethod } from '../clientTypes';
import { ContractRowDTO } from '../clientTypes/DTOs/ContractsDTO';
import { HubspotContractSnapshot, HubspotSalesDealSnapshot } from '../clientTypes/misc';
import { TimelineEventDTO } from './studentInsights.apis';
import { UserJourneyHubspotDTO } from './userJourney.apis';

export type CaseTrackerStudentDTO = {
  _id: string;
  fullName: string;
  email?: string;
  phone?: string;
  graduationYear?: number;
  tier?: number;
  isDeactivated?: boolean;
  createdAt?: string;
  parent: { fullName?: string; email?: string; phone?: string };
  strategist?: { _id: string; fullName: string } | null;
};

export type CaseTrackerContactDTO = {
  at: string;
  form: string;
  title: string;
  detail?: string;
  by?: string;
  url?: string;
  source: 'hubspot' | 'agora';
};

export type CaseTrackerMeetingDTO = {
  _id: string;
  scheduledDate: string;
  status: number;
  systemType?: string;
  reason?: string;
  mentor?: string;
};

export type CaseTrackerEnrollmentDTO = {
  _id: string;
  courseTitle: string;
  courseColor?: string;
  status?: number;
  startDate?: string;
  mentor?: string;
  sessionsCount: number;
  sessionsDone: number;
  sessionsScheduled: number;
  lastSessionAt?: string;
  nextSessionAt?: string;
  contractIds: string[];
};

export type CaseTrackerDTO = {
  student: CaseTrackerStudentDTO;
  contracts: ContractRowDTO[];
  enrollments: CaseTrackerEnrollmentDTO[];
  meetings: CaseTrackerMeetingDTO[];
  churn?: { score: number; band: string; drivers: { label: string; detail?: string }[] } | null;
  hubspot: {
    deal?: HubspotContractSnapshot | null;
    salesDeal?: HubspotSalesDealSnapshot | null;
    contact: UserJourneyHubspotDTO;
    lastContact?: CaseTrackerContactDTO | null;
    recentContacts: CaseTrackerContactDTO[];
    events: TimelineEventDTO[];
  };
  generatedAt: string;
};

export const getCaseTracker: ApiDescription = {
  endpoint: '/admin/case-tracker/:id',
  method: RequestsMethod.Get,
};

export type GetCaseTracker = ApiData<unknown, CaseTrackerDTO>;

export const syncCaseTrackerHubspot: ApiDescription = {
  endpoint: '/admin/case-tracker/:id/sync-hubspot',
  method: RequestsMethod.Post,
};

export type SyncCaseTrackerHubspot = ApiData<
  unknown,
  {
    matched: boolean;
    reason?: string;
    dealName?: string;
    stageLabel?: string;
    salesAmount?: number;
  }
>;
